import { Input } from "@/components/ui/input";

const PERIODS = [["all", "Any time"], ["today", "Today"], ["week", "This week"], ["month", "This month"], ["custom", "Custom"]];
const FLAGS = [["hot", "Hot deal"], ["nojob", "No job created"], ["hasjob", "Job created"], ["unread", "Unread"],
  ["bot", "With bot"], ["unassigned", "Unassigned"]];
export const EMPTY_INBOX_FILTER = { period: "all", start: "", end: "", agent: "all", flags: [] };

const istDay = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? String(iso).slice(0, 10) : d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
};
const rangeOf = (f) => {
  const today = istDay(new Date().toISOString());
  const t = new Date(`${today}T00:00:00`);
  const fmt = (d) => d.toLocaleDateString("en-CA");
  if (f.period === "today") return [today, today];
  if (f.period === "week") {
    const s = new Date(t); s.setDate(t.getDate() - ((t.getDay() + 6) % 7));
    const e = new Date(s); e.setDate(s.getDate() + 6);
    return [fmt(s), fmt(e)];
  }
  if (f.period === "month") return [`${today.slice(0, 7)}-01`, `${today.slice(0, 7)}-31`];
  if (f.period === "custom") return [f.start || "0000-00-00", f.end || "9999-99-99"];
  return null;
};

// Filter conversations by enquiry date (first contact), assignee and quick flags.
export const applyInboxFilter = (list, f) => {
  const rng = rangeOf(f);
  return list.filter((c) => {
    if (rng) {
      const d = istDay(c.created_at || c.last_ts);
      if (!d || d < rng[0] || d > rng[1]) return false;
    }
    if (f.agent !== "all" && (c.cs_person_name || "") !== f.agent) return false;
    for (const fl of f.flags) {
      if (fl === "hot" && c.lead_tag !== "hot") return false;
      if (fl === "nojob" && c.has_job) return false;
      if (fl === "hasjob" && !c.has_job) return false;
      if (fl === "unread" && !(c.unread > 0)) return false;
      if (fl === "bot" && !c.bot_active) return false;
      if (fl === "unassigned" && c.cs_person_name) return false;
    }
    return true;
  });
};

export const InboxFilters = ({ value, onChange, agents, count, total }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const toggle = (fl) => set("flags", value.flags.includes(fl) ? value.flags.filter((x) => x !== fl) : [...value.flags, fl]);
  const sel = "h-8 rounded-md border border-brand-line bg-white px-2 text-xs";
  return (
    <div className="space-y-2 border-b border-brand-line px-3 py-2" data-testid="wa-filters">
      <div className="flex flex-wrap gap-2">
        <select className={sel} value={value.period} onChange={(e) => set("period", e.target.value)} data-testid="wa-filter-period">
          {PERIODS.map(([k, l]) => <option key={k} value={k}>{k === "all" ? "Enquired: any time" : `Enquired: ${l}`}</option>)}
        </select>
        {agents.length > 0 && (
          <select className={sel} value={value.agent} onChange={(e) => set("agent", e.target.value)} data-testid="wa-filter-agent">
            <option value="all">Assigned: everyone</option>
            {agents.map((a) => <option key={a} value={a}>Assigned: {a}</option>)}
          </select>
        )}
      </div>
      {value.period === "custom" && (
        <div className="flex items-center gap-2" data-testid="wa-filter-custom">
          <Input type="date" className="h-8 text-xs" value={value.start} onChange={(e) => set("start", e.target.value)} data-testid="wa-filter-start" />
          <span className="text-xs text-slate-400">to</span>
          <Input type="date" className="h-8 text-xs" value={value.end} onChange={(e) => set("end", e.target.value)} data-testid="wa-filter-end" />
        </div>
      )}
      <div className="flex flex-wrap gap-1.5">
        {FLAGS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => toggle(k)} data-testid={`wa-filter-flag-${k}`}
            className={`rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors duration-150 ${value.flags.includes(k) ? "border-crimson-500 bg-crimson-50 text-crimson-700" : "border-brand-line text-slate-600 hover:bg-slate-50"}`}>
            {l}
          </button>
        ))}
        {(value.period !== "all" || value.agent !== "all" || value.flags.length > 0) && (
          <button type="button" onClick={() => onChange(EMPTY_INBOX_FILTER)} className="px-1 text-[11px] text-slate-500 underline" data-testid="wa-filter-clear">
            Clear
          </button>
        )}
      </div>
      <p className="text-[11px] text-slate-400" data-testid="wa-filter-count">{count} of {total} conversations</p>
    </div>
  );
};
